import { Vector2, Vector3 } from "three";

/**
 * This is a quick manual port of linear_camera_cal.py to TypeScript
 * See aircam/third_party_modules/symforce_module/symforce/symforce/cam/linear_camera_cal.py
 */
export class LinearCameraCal {
  NUM_DISTORTION_COEFFS = 0;
  focal_length: Vector2;
  principal_point: Vector2;
  distortion_coeffs: [] = [];

  constructor(focal_length: Vector2, principal_point: Vector2) {
    this.focal_length = focal_length;
    this.principal_point = principal_point;
  }

  // @ts-ignore
  static project(point: Vector3, epsilon: number = 0): [Vector2, number] {
    // TODO(aaron, vincent):  A couple things here that should be fixed either by moving this to be
    // autogenerated, or before this is more widely used:
    //
    //     1) This is unsafe, in that the result pixel may be NaN if is_valid is false
    //     2) This uses a different convention for is_valid than elsewhere - is_valid will be -1 or
    //        0 for invalid, 1 for valid
    const x = point.x;
    const y = point.y;
    const z = point.z;
    return [new Vector2(x / z, y / z), Math.sign(point.z)];
  }

  pixel_from_unit_depth(unit_depth_coords: Vector2): Vector2 {
    return new Vector2(
      unit_depth_coords.x * this.focal_length.x + this.principal_point.x,
      unit_depth_coords.y * this.focal_length.y + this.principal_point.y
    );
  }

  unit_depth_from_pixel(pixel: Vector2): Vector2 {
    return new Vector2(
      (pixel.x - this.principal_point.x) / this.focal_length.x,
      (pixel.y - this.principal_point.y) / this.focal_length.y
    );
  }

  pixel_from_camera_point(point: Vector3): [Vector2, number] {
    const [unit_depth, is_valid] = LinearCameraCal.project(point);
    return [this.pixel_from_unit_depth(unit_depth), is_valid];
  }

  camera_ray_from_pixel(pixel: Vector2): [Vector3, number] {
    const unit_depth = this.unit_depth_from_pixel(pixel);
    const camera_ray: Vector3 = new Vector3(unit_depth.x, unit_depth.y, 1);
    const is_valid = 1;
    return [camera_ray, is_valid];
  }

  clone(): LinearCameraCal {
    return new LinearCameraCal(this.focal_length.clone(), this.principal_point.clone());
  }
}
